import dayjs from 'dayjs'
import { arrayHasValues } from 'helpers/utils'
import { getTimeData } from '../../helpers'

export const isDisabledDate = (dates, date) => !arrayHasValues(getTimeData(dates, date) || [])

export const canProceedBack = (dates, month) =>
  Boolean(dates && dates[dayjs(month).subtract(1, 'month').format('MM/YYYY')])

export const canProceedForward = (dates, month) =>
  Boolean(dates && dates[dayjs(month).add(1, 'month').format('MM/YYYY')])
